import { render, staticRenderFns } from "./BaseROInput.vue?vue&type=template&id=fed27182&scoped=true"
import script from "./BaseROInput.vue?vue&type=script&lang=js"
export * from "./BaseROInput.vue?vue&type=script&lang=js"
import style0 from "./BaseROInput.vue?vue&type=style&index=0&id=fed27182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed27182",
  null
  
)

export default component.exports